import { render } from "./Hotspot33.vue?vue&type=template&id=6d5f01ed&scoped=true&ts=true"
import script from "./Hotspot33.vue?vue&type=script&lang=ts"
export * from "./Hotspot33.vue?vue&type=script&lang=ts"

import "./Hotspot33.vue?vue&type=style&index=0&id=6d5f01ed&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5f01ed"]])

export default __exports__